import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, HeartPulse, User } from "lucide-react";

const HERO_IMG = "/images/marypawpins/white-cockapoo-viaduct-buttercups.webp";

const TRUST = [
  { icon: ShieldCheck, label: "Fully insured" },
  { icon: HeartPulse, label: "Canine first-aid trained" },
  { icon: User, label: "Founder-led care" },
];

export const Hero = () => (
  <section className="relative min-h-[92vh] flex items-end" data-testid="hero-section">
    <div className="absolute inset-0">
      <img
        src={HERO_IMG}
        alt="A happy white cockapoo in the buttercups at Mary's Meadow with Culloden Viaduct behind"
        className="w-full h-full object-cover object-[50%_45%] anim-fade-in"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#1E241B]/85 via-[#1E241B]/35 to-[#1E241B]/15" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#1E241B]/45 via-[#1E241B]/10 to-transparent" />
    </div>

    <div className="relative w-full max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pb-16 sm:pb-24 pt-40">
      <p className="eyebrow-light anim-fade-up" data-testid="hero-eyebrow">
        Personal pet care · Inverness &amp; the Highlands
      </p>
      <h1
        className="font-serif text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-medium text-[#F7F4ED] tracking-tight leading-[1.05] mt-5 max-w-3xl anim-fade-up anim-delay-1"
        data-testid="hero-heading"
      >
        Trusted care.<br />Highland adventures.
      </h1>
      <p className="mt-6 max-w-xl text-base sm:text-lg leading-relaxed text-[#F7F4ED]/85 anim-fade-up anim-delay-2" data-testid="hero-subcopy">
        Dog walking, in-home pet sitting and home visits, personally delivered by
        Carly. From Mary's Meadow to care at home, every service is built around
        your pet and their routine.
      </p>
      <div className="mt-9 flex flex-wrap items-center gap-4 anim-fade-up anim-delay-3">
        <Link
          to="/contact"
          data-testid="enquire-hero-button"
          className="inline-flex items-center gap-2 rounded-full bg-[#F7F4ED] text-[#292A26] px-7 py-3.5 text-sm font-semibold hover:bg-white transition-colors"
        >
          Enquire About Availability
          <ArrowRight className="w-4 h-4" />
        </Link>
        <Link
          to="/dog-walking"
          data-testid="explore-walking-button"
          className="inline-flex items-center gap-2 rounded-full border border-[#F7F4ED]/40 text-[#F7F4ED] px-7 py-3.5 text-sm font-semibold hover:bg-[#F7F4ED]/10 transition-colors"
        >
          Explore Dog Walking
        </Link>
      </div>
      <div className="mt-12 flex flex-wrap gap-x-8 gap-y-3 anim-fade-up anim-delay-4" data-testid="hero-trust-details">
        {TRUST.map(({ icon: Icon, label }) => (
          <span key={label} className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.16em] font-medium text-[#F7F4ED]/75">
            <Icon className="w-4 h-4 text-[#D8B7B0]" />
            {label}
          </span>
        ))}
      </div>
    </div>
  </section>
);
